/* src/app/settings/partials/user-role-form/user-role-form.component.scss */
/*# sourceMappingURL=user-role-form.component.css.map */
